import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

// 订单
export default [
  {
    path: '/courierView/order',
    component: Loadable({
      loader: () => import('@/pages/order/index'),
      loading: LoadingComponent
    })
  },
  {
    component: Loadable({
      loader: () => import('@/pages/order/cancelReason/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/orderCancelReason/:orderNumber',
    meta: {
      title: '取消订单'
    }
  },
  {
    path: '/courierView/surpriseOrderExplain',
    component: Loadable({
      loader: () => import('@/pages/order/surpriseOrderExplain/index'),
      loading: LoadingComponent
    }),
    meta: {
      title: '什么是新惊喜单'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/order/newCancelReason/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/newOrderCancelReason/:orderNumber',
    meta: {
      title: '无法完成订单'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/order/newCancelReasonRetain/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/newCancelReasonRetain',
    meta: {
      title: '无法完成订单'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/order/exampleDiagram/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/exampleDiagram',
    meta: {
      title: '示例图'
    }
  }
]
